import { useMemo } from "react";
import { collection, query, where } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useCollection } from "./useCollection";

/**
 * Üretim aşaması etiketleri — `statuses` sözlüğünde `category: "production"`.
 *
 * ★ SİPARİŞTE AŞAMANIN ETİKETİ YOK, YALNIZCA KİMLİĞİ VAR.
 * `orders/{id}.productionStatus` üretim kaydının statüsünü taşır ve canlıda
 * güvenilirdir (ölçüm 14.09.2026: 4.400 siparişin 4.400'ünde üretim kaydıyla
 * aynı). Ama `productionStatusLabel` alanını HİÇBİR sunucu yolu yazmıyor
 * (0/4.400); sipariş listesi o alanı okuduğu için ekranda "Üretim: prod-cnc"
 * gibi ham kimlik görünüyordu. Etiket burada sözlükten çözülür — sözlükte
 * yeniden adlandırılan aşama her ekranda anında güncellenir, ayna yazılmaz.
 */
export interface StageLabels {
  labels: ReadonlyMap<string, string>;
  loading: boolean;
}

interface StageDoc {
  label?: string;
}

export function useProductionStageLabels(): StageLabels {
  const q = useCollection<StageDoc>(
    () => query(collection(db, "statuses"), where("category", "==", "production")),
    [],
  );
  const labels = useMemo(
    () => new Map(q.docs.map((d) => [d.id, (d.label ?? "").trim() || d.id] as const)),
    [q.docs],
  );
  return useMemo(() => ({ labels, loading: q.loading }), [labels, q.loading]);
}

/**
 * Aşama kimliğinin ekrandaki adı.
 *
 * Sözlük yüklenirken `null` döner: bir anlığına "prod-cnc" basıp sonra "Cnc"ye
 * dönmek, kullanıcıya iki farklı aşama görmüş gibi hissettirir. Sözlük yüklendiği
 * hâlde kimlik orada yoksa ham kimlik gösterilir — bilinmeyen bir aşamayı
 * gizlemek, onu hiç yokmuş gibi sunmak olurdu.
 */
export function stageLabelOf(stages: StageLabels, statusId: string | null | undefined): string | null {
  if (!statusId) return null;
  const label = stages.labels.get(statusId);
  if (label) return label;
  return stages.loading ? null : statusId;
}
